import React, { useState, useEffect } from "react";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Collapse from "@material-ui/core/Collapse";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import styles from "./NavbarSlider.module.css";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";

import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles({
  paper: {
    background: "#00293B",
    color: "#F2F2F6",
    width: "50%",
  },
  dividerColor: {
    backgroundColor: "white",
    opacity: "0.7",
  },
});

const NavbarSlider = ({ open, handleToggle, handleClose }) => {
  const [naValue, setnaValue] = useState(0);
  const classes = useStyles();

  const [openConfig, setOpenConfig] = useState(false);
  const [openCurr, setOpenCurr] = useState(false);
  const [openAss, setOpenAss] = useState(false);
  const [openAtt, setOpenAtt] = useState(false);

  const handleConfigClick = () => {
    setOpenConfig(!openConfig);
  };

  const handleCurrClick = () => {
    setOpenCurr(!openCurr);
  };

  const handleAssClick = () => {
    setOpenAss(!openAss);
  };

  const handleAttClick = () => {
    setOpenAtt(!openAtt);
  };

  useEffect(() => {
    if (window.location.pathname == "/" && naValue != 0) {
      setnaValue(0);
    } else if (window.location.pathname.indexOf("/dashboard")>-1 && naValue != 1) {
      setnaValue(1);
    } else if (window.location.pathname.indexOf("/attainment")>-1 && naValue != 2) {
      setnaValue(2);
    } else if (window.location.pathname.indexOf("/reports")>-1 && naValue != 3) {
      setnaValue(3);
    } else if (window.location.pathname.indexOf("/configuration")>-1&& naValue != 4) {
      setnaValue(4);
    } else if (window.location.pathname.indexOf("/survey")>-1 && naValue != 5) {
      setnaValue(5);
    } else if (
      window.location.pathname.indexOf("/faculty-contribution")>-1 &&
      naValue != 6
    ) {
      setnaValue(6);
    } else if (window.location.pathname.indexOf("/utilities")>-1 && naValue != 7) {
      setnaValue(7);
    } else if (window.location.pathname.indexOf("/assessments")>-1 && naValue != 8) {
      setnaValue(8);
    } else if (window.location.pathname.indexOf("/curriculum")>-1 && naValue != 9) {
      setnaValue(9);
    }
  }, [naValue]);
  return (
    <>
      <div className={styles.sliderWrapper}>
        <Drawer
          anchor="left"
          open={open}
          onClose={() => handleToggle()}
          classes={{ paper: classes.paper }}
        >
          <List style={{ padding: "0" }}>
            <ListItem
              button
              className={naValue == 0 ? styles.active : undefined}
              onClick={() => {
                setnaValue(0);
                handleClose();
              }}
              component={Link}
              to="/"
            >
              <ListItemText>Home</ListItemText>
            </ListItem>
            <Divider classes={{ root: classes.dividerColor }} />
            <ListItem
              button
              className={naValue == 1 ? styles.active : undefined}
              onClick={() => {
                setnaValue(1);
                handleClose();
              }}
              component={Link}
              to="/dashboard"
            >
              <ListItemText>Dashboard</ListItemText>
            </ListItem>
            <Divider classes={{ root: classes.dividerColor }} />
            <ListItem
              button
              className={naValue == 2 ? styles.active : undefined}
              onClick={() => {
                setnaValue(2);
                handleAttClick();
              }}
              component={Link}
              to="/attainment"
            >
              <ListItemText>Attainment</ListItemText>
              <ListItemIcon>
                {openAtt ? <ExpandLess /> : <ExpandMore />}
              </ListItemIcon>
            </ListItem>
            <Divider classes={{ root: classes.dividerColor }} />
            {/********************************************************** */}
            <Collapse in={openAtt} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  to="/attainment"
                  component={Link}
                  onClick={() => {
                    setnaValue(2);
                    handleClose();
                  }}
                >
                  <ListItemText>Attainment level VS target</ListItemText>
                </ListItem>
                <Divider classes={{ root: classes.dividerColor }} />
                <ListItem
                  button
                  to="/attainment/ise-mse-data-import"
                  component={Link}
                  onClick={() => {
                    setnaValue(2);
                    handleClose();
                  }}
                >
                  <ListItemText>ISE & MSE Data import</ListItemText>
                </ListItem>
                <Divider classes={{ root: classes.dividerColor }} />
                <ListItem
                  button
                  to="/attainment/ese-data-import"
                  component={Link}
                  onClick={() => {
                    setnaValue(2);
                    handleClose();
                  }}
                >
                  <ListItemText>ESE Data import</ListItemText>
                </ListItem>
                <Divider classes={{ root: classes.dividerColor }} />
                <ListItem
                  button
                  to="/attainment/co-attainment"
                  component={Link}
                  onClick={() => {
                    setnaValue(2);
                    handleClose();
                  }}
                >
                  <ListItemText>CO Attainment (ISE & MSE)</ListItemText>
                </ListItem>
                <Divider classes={{ root: classes.dividerColor }} />
                <ListItem
                  button
                  to="/attainment/course-co-attainment"
                  component={Link}
                  onClick={() => {
                    setnaValue(2);
                    handleClose();
                  }}
                >
                  <ListItemText>Course - CO Attainment</ListItemText>
                </ListItem>
                <Divider classes={{ root: classes.dividerColor }} />
                <ListItem
                  button
                  to="/attainment/course-attainment-comparision"
                  component={Link}
                  onClick={() => {
                    setnaValue(2);
                    handleClose();
                  }}
                >
                  <ListItemText>Course Attainment Comparison</ListItemText>
                </ListItem>
                <Divider classes={{ root: classes.dividerColor }} />
                <ListItem
                  button
                  to="/attainment/po-attainment"
                  component={Link}
                  onClick={() => {
                    setnaValue(2);
                    handleClose();
                  }}
                >
                  <ListItemText>Program Level Course</ListItemText>
                </ListItem>
                <Divider classes={{ root: classes.dividerColor }} />
                <ListItem
                  button
                  to="/attainment/program-level-course"
                  component={Link}
                  onClick={() => {
                    setnaValue(2);
                    handleClose();
                  }}
                >
                  <ListItemText>CAY PO Attainment</ListItemText>
                </ListItem>
                <Divider classes={{ root: classes.dividerColor }} />
                <ListItem button>
                  <ListItemText
                    to="/attainment/individual-po-attainment"
                    component={Link}
                    onClick={() => {
                      setnaValue(2);
                      handleClose();
                    }}
                  >
                    Individual PO Attainment
                  </ListItemText>
                </ListItem>
                <Divider classes={{ root: classes.dividerColor }} />
                <ListItem
                  button
                  to="/attainment/data-analysis"
                  component={Link}
                  onClick={() => {
                    setnaValue(2);
                    handleClose();
                  }}
                >
                  <ListItemText>Data Analysis</ListItemText>
                </ListItem>
                <Divider classes={{ root: classes.dividerColor }} />
                <ListItem
                  button
                  to="/attainment/student-co-attainment"
                  component={Link}
                  onClick={() => {
                    setnaValue(2);
                    handleClose();
                  }}
                >
                  <ListItemText>Student CO Attainment</ListItemText>
                </ListItem>
                <Divider classes={{ root: classes.dividerColor }} />
                <ListItem
                  button
                  to="/attainment/student-po-attainment"
                  component={Link}
                  onClick={() => {
                    setnaValue(2);
                    handleClose();
                  }}
                >
                  <ListItemText>Student PO Attainment</ListItemText>
                </ListItem>
                <Divider classes={{ root: classes.dividerColor }} />
                <ListItem
                  button
                  to="/attainment/student-improvement-plan"
                  component={Link}
                  onClick={() => {
                    setnaValue(2);
                    handleClose();
                  }}
                >
                  <ListItemText>Student Improvement Plan</ListItemText>
                </ListItem>
                <Divider classes={{ root: classes.dividerColor }} />
              </List>
            </Collapse>
            <Divider classes={{ root: classes.dividerColor }} />
            <ListItem
              button
              className={naValue == 3 ? styles.active : undefined}
              onClick={() => {
                setnaValue(3);
                handleClose();
              }}
              component={Link}
              to="/reports"
            >
              <ListItemText>Reports</ListItemText>
            </ListItem>
            <Divider classes={{ root: classes.dividerColor }} />
            <ListItem
              button
              className={naValue == 4 ? styles.active : undefined}
              onClick={() => {
                setnaValue(4);
                handleConfigClick();
              }}
              component={Link}
              to="/configuration"
            >
              <ListItemText>Configuration</ListItemText>
              <ListItemIcon>
                {openConfig ? <ExpandLess /> : <ExpandMore />}
              </ListItemIcon>
            </ListItem>
            <Divider classes={{ root: classes.dividerColor }} />
            {/********************************************************** */}
            <Collapse in={openConfig} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(4);
                    handleClose();
                  }}
                  component={Link}
                  to="/configuration"
                >
                  <ListItemText>Organisation</ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(4);
                    handleClose();
                  }}
                  component={Link}
                  to="/configuration/department"
                >
                  <ListItemText>Department</ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(4);
                    handleClose();
                  }}
                  component={Link}
                  to="/configuration/program-type"
                >
                  <ListItemText>Program Type</ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(4);
                    handleClose();
                  }}
                  component={Link}
                  to="/configuration/program-mode"
                >
                  <ListItemText>Program Mode</ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(4);
                    handleClose();
                  }}
                  component={Link}
                  to="/configuration/program"
                >
                  <ListItemText>Program</ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(4);
                    handleClose();
                  }}
                  component={Link}
                  to="/configuration/users"
                >
                  <ListItemText>Users</ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(4);
                    handleClose();
                  }}
                  component={Link}
                  to="/configuration/program-outcome"
                >
                  <ListItemText>Program Outcome (PO)Type</ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(4);
                    handleClose();
                  }}
                  component={Link}
                  to="/configuration/generic-program-outcomes"
                >
                  <ListItemText>Generic Program Outcome(PO)</ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(4);
                    handleClose();
                  }}
                  component={Link}
                  to="/configuration/course-type"
                >
                  <ListItemText>Course Type</ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(4);
                    handleClose();
                  }}
                  component={Link}
                  to="/configuration/delivery-method"
                >
                  <ListItemText>Delivery Method</ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(4);
                    handleClose();
                  }}
                  component={Link}
                  to="/configuration/lab-category"
                >
                  <ListItemText>Lab Category</ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(4);
                    handleClose();
                  }}
                  component={Link}
                  to="/configuration/blooms-domain"
                >
                  <ListItemText>Bloom's Domain </ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(4);
                    handleClose();
                  }}
                  component={Link}
                  to="/configuration/blooms-level"
                >
                  <ListItemText>Bloom's Level</ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(4);
                    handleClose();
                  }}
                  component={Link}
                  to="/configuration/map-level-weightage"
                >
                  <ListItemText>Map Level Weightage</ListItemText>
                </ListItem>
              </List>
            </Collapse>
            <Divider classes={{ root: classes.dividerColor }} />
            {/************************************************************* */}
            <ListItem
              button
              className={naValue == 5 ? styles.active : undefined}
              onClick={() => {
                setnaValue(5);
                handleClose();
              }}
              component={Link}
              to="/survey"
            >
              <ListItemText>Survey</ListItemText>
            </ListItem>
            <Divider classes={{ root: classes.dividerColor }} />
            <ListItem
              button
              className={naValue == 6 ? styles.active : undefined}
              onClick={() => {
                setnaValue(6);
                handleClose();
              }}
              component={Link}
              to="/faculty-contribution"
            >
              <ListItemText>Faculty Contribution</ListItemText>
            </ListItem>
            <Divider classes={{ root: classes.dividerColor }} />
            <ListItem
              button
              className={naValue == 7 ? styles.active : undefined}
              onClick={() => {
                setnaValue(7);
                handleClose();
              }}
              component={Link}
              to="/utilities"
            >
              <ListItemText>Utilities</ListItemText>
            </ListItem>
            <Divider classes={{ root: classes.dividerColor }} />
            <ListItem
              button
              className={naValue == 8 ? styles.active : undefined}
              onClick={() => {
                setnaValue(8);
                handleAssClick();
              }}
              component={Link}
              to="/assessment"
            >
              <ListItemText>Assessment</ListItemText>
              <ListItemIcon>
                {openAss ? <ExpandLess /> : <ExpandMore />}
              </ListItemIcon>
            </ListItem>
            <Divider classes={{ root: classes.dividerColor }} />
            {/************************************************************** */}
            <Collapse in={openAss} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(8);
                    handleClose();
                  }}
                  component={Link}
                  to="/assessment"
                >
                  <ListItemText>QuestionBank</ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(8);
                    handleClose();
                  }}
                  component={Link}
                  to="/assessments/manage-ise-mse-occassion"
                >
                  <ListItemText>Manage ISE & MSE Occassion</ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(8);
                    handleClose();
                  }}
                  component={Link}
                  to="/assessments/manage-ise-mse-qp-rubrics"
                >
                  <ListItemText>
                    Manage ISE & MSE Question Paper and Rubrics
                  </ListItemText>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(8);
                    handleClose();
                  }}
                  component={Link}
                  to="/assessments/manage-ese-qp"
                >
                  <ListItemText>Manage ESE Question Paper</ListItemText>
                </ListItem>
              </List>
            </Collapse>
            <Divider classes={{ root: classes.dividerColor }} />
            {/***************************************************************** */}
            <ListItem
              button
              className={naValue == 9 ? styles.active : undefined}
              onClick={() => {
                setnaValue(9);
                handleCurrClick();
              }}
              component={Link}
              to="/curriculum"
            >
              <ListItemText>Curriculum</ListItemText>
              <ListItemIcon>
                {openCurr ? <ExpandLess /> : <ExpandMore />}
              </ListItemIcon>
            </ListItem>
            <Divider classes={{ root: classes.dividerColor }} />
            {/********************************************************** */}
            <Collapse in={openCurr} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  onClick={() => {
                    setnaValue(9);
                    handleClose();
                  }}
                  component={Link}
                  to="/curriculum"
                >
                  <ListItemText>Courses</ListItemText>
                </ListItem>

                <ListItem
                  button
                  onClick={() => {
                    setnaValue(9);
                    handleClose();
                  }}
                  component={Link}
                  to="/curriculum/course-outcome"
                >
                  <ListItemText>Course Outcome</ListItemText>
                </ListItem>

                <ListItem
                  button
                  onClick={() => {
                    setnaValue(9);
                    handleClose();
                  }}
                  component={Link}
                  to="/curriculum/co-po-maping"
                >
                  <ListItemText>CO to MO Mapping </ListItemText>
                </ListItem>

                <ListItem
                  button
                  onClick={() => {
                    setnaValue(9);
                    handleClose();
                  }}
                  component={Link}
                  to="/curriculum/manage-topic-tlos"
                >
                  <ListItemText>Manage Topic and TLO's</ListItemText>
                </ListItem>

                <ListItem
                  button
                  onClick={() => {
                    setnaValue(9);
                    handleClose();
                  }}
                  component={Link}
                  to="/curriculum/manage-lab-experiment-tlos"
                >
                  <ListItemText>Manage Lab Experiment and TLO's</ListItemText>
                </ListItem>
              </List>
            </Collapse>
          </List>
        </Drawer>
      </div>
    </>
  );
};

export default NavbarSlider;
